import { UseQueryResult, useQuery } from "react-query";

import { IVariantInventory, Inventory } from "../../utils/api";
import { useAuth } from "../useAuth";

export const useGetVariantInventory = (
    variantId: string,
    options?: { enabled?: boolean },
): UseQueryResult<IVariantInventory, unknown> => {
    const { token } = useAuth();

    return useQuery<IVariantInventory, unknown>(
        ["inventory", variantId],
        async () => {
            if (!token) {
                throw new Error(
                    "Cannot fetch variant inventory without authorization token.",
                );
            }

            return await Inventory.getVariantInventory({ variantId, token });
        },
        {
            enabled: options?.enabled !== false && !!token && !!variantId,
        },
    );
};
